define('plugin/invoice/collection/InvoicePromotionInstanceCollection',['require','lib/collection/BaseCollection','plugin/invoice/model/InvoicePromotionInstanceModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var InvoicePromotionInstanceModel = require('plugin/invoice/model/InvoicePromotionInstanceModel');

    /**
     * Invoice promotion collection
     *
     * @class InvoicePromotionInstanceCollection
     */
    return BaseCollection.extend({

        model: InvoicePromotionInstanceModel

    });

});
